import { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, sendWhatsAppTemplate } from "../../Utility/constants";
import Footer from "../common/Footer";
import "./StudentPersonalDetails.css";
import TeacherHeader from "../common/TeacherHeader";
import { Table, Button, Spinner, Form, } from "react-bootstrap";

const AttendanceMaster = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false); // ✅ loader for fetch
  const [saving, setSaving] = useState(false);  // ✅ loader for save
  const [attendanceDate, setAttendanceDate] = useState(""); // store selected date

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const teacherId = localStorage.getItem("userID");
      let url = `${baseUrl}/api/Attendance/GetStudentsWithAttendanceByTeacherId?TeacherId=${teacherId}`;
      if (attendanceDate) {
        url += `&attendanceDate=${attendanceDate}`;
      }
      const response = await axios.get(url);
      if (response?.data) {
        const students = response.data
          .map((s) => ({
            ...s,
            rollNo: Number.parseInt(s.rollNo, 10),
            attendanceStatus:
              s.attendanceStatus === "Not Marked" || !s.attendanceStatus
                ? "P"
                : s.attendanceStatus,
            isDisabled: !!s.attendanceDate,
          }))
          .sort((a, b) => a.rollNo - b.rollNo);
        setData(students);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      toast.error("Failed to load student details.");
    } finally {
      setLoading(false);
    }
  };

  const hasAbsentStudent = data.some(
    x => x.attendanceStatus === "A"
  );

  const handleAttendanceChange = (index, value) => {
    const updatedData = [...data];
    updatedData[index].attendanceStatus = value;
    updatedData[index].isDisabled = false; // enable after teacher changes
    setData(updatedData);
  };

  const handle_Save_1 = async () => {
    setSaving(true);
    try {
      const createdBy = Number(localStorage.getItem("userID"));

      const payload = data
        //.filter((item) => !item.isDisabled)
        .map((item) => ({
          studentId: item.studentId,
          standardId: item.standardId,
          sectionId: item.sectionId,
          status: item.attendanceStatus || "P",
          createdBy,
          attendanceDate
        }));

      if (payload.length === 0) {
        toast.info("No new attendance to mark.");
        setSaving(false);
        return;
      }

      // Get absent students
      const absentStudents = payload.filter((x) => x.status === "A");

      if (absentStudents.length > 0) {
        for (const absent of absentStudents) {
          // Find full student record to access contact numbers
          const studentInfo = data.find(
            (s) => s.studentId === absent.studentId
          );

          if (studentInfo) {
            const contactNo =
              studentInfo.motherContactNumber ||
              studentInfo.parentContactNumber;

            if (contactNo) {
              const templateVariables = {
                "templateVariable-parentname-1": studentInfo.parentName || "Parent",
                "templateVariable-studentname-2": `${studentInfo.firstName} ${studentInfo.middleName} ${studentInfo.lastName}`,
                "templateVariable-Class-3": studentInfo.standardName || "",
                "templateVariable-div-4": studentInfo.sectionName || "",
                "templateVariable-stream-5": studentInfo.stream || "",
                "templateVariable-classteachername-6": studentInfo.teacherName || "",
                "templateVariable-classteachermobileno-7": studentInfo.classTeacherMobile || "",
                "templateVariable-schoolname-8": studentInfo.schoolName || "",
              };
              await sendWhatsAppTemplate(contactNo, 250125, templateVariables);
              console.log(`Template sent to ${studentInfo.firstName + studentInfo.middleName + studentInfo.lastName}'s parent.`);
            } else {
              console.warn(
                `No contact number found for student ID: ${absent.studentId}`
              );
            }
          }
        }
      }
      await axios.put(`${baseUrl}/api/Attendance/MarkAttendance`, payload);
      toast.success("Attendance saved successfully!");
      setData([]);
      setAttendanceDate('')
    } catch (error) {
      console.error("Error saving attendance", error);
      toast.error("Failed to save attendance.");
      setData([]);
    } finally {
      setSaving(false);
      setData([]);
    }
  };

  const handleSave = async () => {
    setSaving(true);

    try {
      const createdBy = Number(localStorage.getItem("userID"));

      const payload = data.map((item) => ({
        studentId: item.studentId,
        standardId: item.standardId,
        sectionId: item.sectionId,
        status: item.attendanceStatus || "P",
        createdBy,
        attendanceDate
      }));

      if (payload.length === 0) {
        toast.info("No new attendance to mark.");
        setSaving(false);
        return;
      }

      // Get today's date in YYYY-MM-DD format
      const todayDate = getTodayDate();

      // Send WhatsApp ONLY when attendance is being marked for today
      if (attendanceDate === todayDate) {

        const absentStudents = payload.filter(
          (x) => x.status === "A"
        );

        if (absentStudents.length > 0) {

          for (const absent of absentStudents) {

            const studentInfo = data.find(
              (s) => s.studentId === absent.studentId
            );

            if (studentInfo) {

              const contactNo =
                studentInfo.motherContactNumber ||
                studentInfo.parentContactNumber;

              if (contactNo) {

                const templateVariables = {
                  "templateVariable-parentname-1":
                    studentInfo.parentName || "Parent",

                  "templateVariable-studentname-2":
                    `${studentInfo.firstName || ""} ${studentInfo.middleName || ""} ${studentInfo.lastName || ""}`.trim(),

                  "templateVariable-Class-3":
                    studentInfo.standardName || "",

                  "templateVariable-div-4":
                    studentInfo.sectionName || "",

                  "templateVariable-stream-5":
                    studentInfo.stream || "",

                  "templateVariable-classteachername-6":
                    studentInfo.teacherName || "",

                  "templateVariable-classteachermobileno-7":
                    studentInfo.classTeacherMobile || "",

                  "templateVariable-schoolname-8":
                    studentInfo.schoolName || "",
                };

                await sendWhatsAppTemplate(
                  contactNo,
                  250125,
                  templateVariables
                );

                console.log(
                  `WhatsApp sent to ${studentInfo.firstName} ${studentInfo.middleName || ""} ${studentInfo.lastName || ""}'s parent.`
                );

              } else {

                console.warn(
                  `No contact number found for student ID: ${absent.studentId}`
                );

              }
            }
          }
        }

      } else {

        console.log(
          `Attendance date ${attendanceDate} is not today (${todayDate}). WhatsApp notification skipped.`
        );

      }

      // Save attendance
      await axios.put(
        `${baseUrl}/api/Attendance/MarkAttendance`,
        payload
      );

      toast.success("Attendance saved successfully!");

      setData([]);
      setAttendanceDate("");

    } catch (error) {

      console.error("Error saving attendance", error);

      toast.error("Failed to save attendance.");

      setData([]);

    } finally {

      setSaving(false);
    }
  };

  const GetDateData = (dateValue) => {
    setAttendanceDate(dateValue);
    setData([]);
  }

  const handleFetchData = () => {
    fetchData();
  }

  return (
    <>
      <TeacherHeader />
      <div className="container mt-5 mb-5">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
          <h2 className="mb-3 mb-md-0">Manage Attendance</h2>

          <div className="d-flex align-items-center gap-2">
            <Form.Control
              type="date"
              value={attendanceDate}
              onChange={(e) => GetDateData(e.target.value)}
              style={{ width: "180px" }}
            />
            <Button
              variant="primary"
              onClick={handleFetchData}
              disabled={!attendanceDate}
            >
              Fetch Data
            </Button>

            <Button
              variant="primary"
              onClick={handleSave}
              // disabled={!data.length > 0 || !hasAbsentStudent}
              disabled={!data.length > 0}
            >
              {saving ? "Saving..." : "Save Attendance"}
            </Button>
          </div>
        </div>

        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Table striped bordered hover responsive>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Roll No</th>
                <th>GR No</th>
                <th>Attendance</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.studentId}>
                    <td>{index + 1}</td>
                    <td>{`${item.firstName} ${item.middleName || ""} ${item.lastName || ""}`.trim()}</td>
                    <td>{item.rollNo || ""}</td>
                    <td>{item.generalRegisterNo || ""}</td>
                    <td>
                      <select
                        value={item.attendanceStatus}
                        onChange={(e) => handleAttendanceChange(index, e.target.value)}
                        disabled={item.isDisableForPresent}
                      //disabled={item.attendanceDate && item.attendanceStatus === 'P'}
                      >
                        <option value="P">Present</option>
                        <option value="A">Absent</option>
                      </select>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default AttendanceMaster;
